module.exports = __webpack_public_path__ + "static/media/system.9c3a46ca.png";